import { format, h } from 'typewriter-editor';
import './track-changes.css';

format({
  name: 'ins',
  selector: 'format-track-ins',
  greedy: false,
  render: (attributes, children) =>
    attributes.ins == null ? null : h('format-track-ins', { contentEditable: false }, children),
});

format({
  name: 'd3l',
  selector: 'format-track-d3l',
  greedy: false,
  render: (attributes, children) =>
    attributes.d3l == null ? null : h('format-track-d3l', { contentEditable: false }, children),
});

format({
  name: 'formatChange',
  selector: 'format-track-format-change',
  greedy: false,
  render: (attributes, children) =>
    attributes.formatChange == null ? null : h('format-track-format-change', { contentEditable: false }, children),
});
